import { DevTool } from '@hookform/devtools';
import { yupResolver } from '@hookform/resolvers/yup';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';

import { acPostRegister } from '../../store/actions';
import { PrimaryButton, Alert } from '../default';

import { FormInputText, FormInputCnpj } from './formInputs';
import { FormValidationCreateClient } from '../../utils/FormValidationCreateClient';

export const CreateAccessCredentialsForm = ({ onClose, setShowSnackbar, setShowErrorToast }) => {
    const defaultValues = {
        email: '',
        cnpj: ''
    }

    const dispatch = useDispatch()
    const [previousErrorState, setPreviousErrorState] = useState(false)

    const isCreatingClient = useSelector(state => state.auth?.isRegistering || false)
    const hasErrorCreatedClient = useSelector(state => state.auth?.hasErrorRegister || false)
    const errorMessage = useSelector(state => state.auth?.errorRegisterMessage || 'Erro ao criar credenciais do cliente!')

    const { control, handleSubmit, formState: { errors } } = useForm({
        defaultValues: defaultValues,
        resolver: yupResolver(FormValidationCreateClient)
    })

    useEffect(() => {
        if (hasErrorCreatedClient && !previousErrorState) {
            if (setShowErrorToast) {
                setShowErrorToast(true, errorMessage)
            }
        }
        setPreviousErrorState(hasErrorCreatedClient)
    }, [hasErrorCreatedClient, previousErrorState, errorMessage, setShowErrorToast])

    const onSubmit = handleSubmit(async (data) => {
        try {
            const cleanCnpj = data.cnpj.replace(/\D/g, '')

            await dispatch(acPostRegister({
                email: data.email,
                cnpj: cleanCnpj
            }));

            onClose();
            setShowSnackbar(true);
        } catch (error) {
            console.error(error);
            if (setShowErrorToast) {
                setShowErrorToast(true, 'Erro ao criar credenciais do cliente!\nVerifique se o email já está cadastrado ou se o CNPJ é válido.');
            }
        }
    })

    return (
        <Box
            component='form' onSubmit={onSubmit} noValidate
            display='flex' flexDirection='column' gap={2}
        >

            <DevTool control={control} />

            <FormInputText
                name='email'
                label='Email'
                control={control}
                errors={errors.email}
                fullWidth
                required
            />

            <FormInputCnpj
                name='cnpj'
                label='CNPJ'
                control={control}
                errors={errors.cnpj}
                fullWidth
                required
            />

            {hasErrorCreatedClient && (
                <Alert severity='error' message={errorMessage} />
            )}

            <PrimaryButton
                label='Criar credenciais do cliente'
                loading={isCreatingClient}
                type='submit'
                fullWidth
            />

        </Box>
    )
}

CreateAccessCredentialsForm.propTypes = {
    onClose: PropTypes.func.isRequired,
    setShowSnackbar: PropTypes.func.isRequired,
    setShowErrorToast: PropTypes.func
}